import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import { Progress } from 'antd';

import style from './index.less';

function ProgressItem({ title = '', max = 0, current = 0, price = 0 }) {

  const percent = useMemo(() => {
    if (max <= 0) {
      return 0;
    }

    return parseInt((current / max) * 100, 10);
  }, [max, current]);

  return (
    <div className={style.item}>
      <div className={style.header}>
        <div className={style.title}>{title}</div>
        {max ? (
          <div className={style.count}>
            {current}/{max}
          </div>
        ) : null}
      </div>
      <div className={`${style.price} ${!price ? style.hide : ''}`}>单价：{price}</div>
      {max ? <Progress percent={percent} showInfo={false} /> : null}
    </div>
  );
}

ProgressItem.propTypes = {
  title: propTypes.string,
  max: propTypes.number,
  current: propTypes.number,
  price: propTypes.number
};

export default ProgressItem;
